import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	languageSelector: 'js-m-download-item__language-selector',
	fileInfo: 'js-m-featured-download__file-info',
	downloadItem: 'js-m-featured-download__item',
	stateHidden: 'h-visuallyhidden',
	loadMoreButton: 'js-load-more-button',
	loadMoreBar: 'js-load-more-bar',
};

@createModule('FeaturedDownload')
/**
 * featured-download module implementation.
 *
 * @author Lars-Olof Kreim <lars-olof.kreim@namics.com>
 */
export class FeaturedDownload extends TerrificSpec {
	$ctx: JQuery;
	isOpen: boolean;

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);
		this.isOpen = false;
		this.showFileInfo();
		this.changeFileInfo();
		this.initLoadMore();

		resolve();
	}
	
	
	showFileInfo() {
		const $languageSelect = this.$ctx.find(`.${classes.languageSelector}`);
		$languageSelect.each((i,e) => {
			var language = $(e).find("option:selected").text();
			$(e).parents(`.${classes.downloadItem}`).find("."+language).addClass("active");
		});
	}
	changeFileInfo() {
		const $languageSelect = this.$ctx.find(`.${classes.languageSelector}`);
		$languageSelect.on("change",function(ev: Event){
			var language = $(ev.currentTarget).find("option:selected").text();
			var activeElement = $(ev.currentTarget).parents(`.${classes.downloadItem}`).find(".active");
			if(activeElement.length == 0) return;
			var curLanguage = activeElement.attr("class").substring(0,2);
			if (language!==curLanguage) {
				$(ev.currentTarget).parents(`.${classes.downloadItem}`).find("span").removeClass("active");
				$(ev.currentTarget).parents(`.${classes.downloadItem}`).find("."+language).addClass("active");
			}
		})
	}
	/**
	 * method handles hide/show of entries
	 *
	 * @returns {void}
	 */
	initLoadMore() {
		// if this an Application/Evergreen and not one of the other download items and it has not yet been opened:
		if (typeof this.$ctx.data('shown-items') !== 'undefined' && this.isOpen === false) {
			const $downloadItems = this.$ctx.find(`.${classes.downloadItem}`);
			let minOfShowDownloadItems = this.$ctx.data('shown-items');
			let PageSizeLoadMore = this.$ctx.data('load-items');

			if ($downloadItems.length <= minOfShowDownloadItems) {
				this.$ctx.find(`.${classes.loadMoreBar}`).addClass(classes.stateHidden);
				$(window).trigger('NavigationInPage:reInitNoClick');
			} else {
				minOfShowDownloadItems++;
				$downloadItems.filter(`:nth-child(n + ` + minOfShowDownloadItems + `)`).addClass(classes.stateHidden);
				$(window).trigger('NavigationInPage:reInitNoClick');

				let currentShowDownloadItems = minOfShowDownloadItems -1;
				this.$ctx.find(`.${classes.loadMoreButton}`).on('click', (ev: any) => {
					let allOfShowDownloadItems = currentShowDownloadItems + PageSizeLoadMore;
					for( var i=0; i<allOfShowDownloadItems; i++ ){
						$downloadItems.eq(i).removeClass(classes.stateHidden);
						currentShowDownloadItems = allOfShowDownloadItems;
						if(allOfShowDownloadItems >= $downloadItems.length) {
							$(ev.currentTarget)
								.parent(`.${classes.loadMoreBar}`)
								.addClass(classes.stateHidden);

							this.isOpen = true;
						}
					}
				});
			}
		}
	}

	stop() {}
}
